function isLeaf(node) {
  return node.field !== void 0;
}
export {
  isLeaf
};
//# sourceMappingURL=gridColumnGrouping.es.js.map
